import React, { Component } from "react";
import ReactDOM from "react-dom";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// import "./styles.css";
import { Button } from "react-bootstrap";


const products = [
  { id: 1, CodeId:"#001", Name:"Taj Villa", City:"Delhi", Yeild:"20%", PropertyType:"Commercial", PropertyService:"buy", IdProof:"Remarks" },
  { id: 2, CodeId:"#002", Name:"Taj Villa", City:"Delhi", Yeild:"20%", PropertyType:"Commercial", PropertyService:"buy", IdProof:"Remarks" },
  { id: 3, CodeId:"#003", Name:"Taj Villa", City:"Delhi", Yeild:"20%", PropertyType:"Commercial", PropertyService:"buy", IdProof:"Remarks" },
  { id: 4, CodeId:"#004", Name:"Taj Villa", City:"Delhi", Yeild:"20%", PropertyType:"Commercial", PropertyService:"buy", IdProof:"Remarks" }
];

class ProjectsTable extends Component {
  constructor() {
    super();
    this.state = {
      // For displaying data
      columns: [
        {
          dataField: "id",
          text: "Serial Number",
          sort: true
        },
     
        {
          dataField: "Name",
          text: "Name",
          sort: true
        },
        {
            dataField: "City",
            text: "City",
            sort: true
          },
             {
          dataField: "Yeild",
          text: "Yeild",
          sort: true
        },
          {
            dataField: "PropertyType",
            text: " Property Type"
          },
          {
            dataField: "PropertyService",
            text: "Property Service",
            sort: true
          },
          {
            dataField: "IdProof",
            text: "ID Proof"
          },
          // {
          //   dataField: "PractionerCertificate",
          //   text: "Practioner Certificate"
          // },
        {
          dataField: "Status",
          text: "Status",
          formatter: this.linkFollow,
          sort: true
        },
        {
          dataField: "Delivery Report",
          text:  "",
          formatter: this.linkFollow2,
          sort: true
        }
      ],
      isFollow: true
    };

    this.onFollowChanged.bind(this);
  }

  onFollowChanged() {
    this.setState({ isFollow: !this.state.isFollow });
    console.log(this.state.isFollow);
  }

  linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
        <>
        
        {/* <span className="status dark-span bg-status">Reject</span> */}
        <span className="status dark-span bg-status">Approved</span>
        {/* <span className="status dark-span bg-status">Under Review</span> */}
     </>
    );
  };
  onFollowChanged2() {
    this.setState({ isFollow: !this.state.isFollow });
    console.log(this.state.isFollow);
  }

  linkFollow2 = (cell, row, rowIndex, formatExtraData) => {
    return (
        <>
        <Link to="/view-project">
         <Button className="trash-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i class="bi bi-eye-fill"></i>
      </Button>
      </Link>

      <Link to="/edit-project">
      <Button className="trash-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i class="bi bi-pencil-square"></i>
      </Button>
        </Link>
      <Button className="trash-btn"
        onClick={() => {
          this.onFollowChanged2(row);
        }}
      >
        <i className="bi bi-trash3-fill"></i>
      </Button>
      

     </>
    );
  };

  render() {
    return (
        <>
       <div className="pract-table user-remarks" style={{overflowX:"auto"}}>
        <BootstrapTable
        insertRow
        deleteRow={true}
        responsive={true}
          keyField="id"
          striped={true}
          className="text-center"
          data={products}
          columns={this.state.columns}
        />
        </div>
      
      </>
    );
  }
}


export default ProjectsTable;